<template>
  <div class="comp-upload-avatar-box">
    <el-upload
      class="avatar-uploader"
      action="/api/blade-resource/oss/endpoint/put-file"
      :show-file-list="false"
      :on-success="handleAvatarSuccess"
      :before-upload="beforeAvatarUpload"
      :on-remove="handleRemove"
      :headers="headers"
      :disabled="disabled"
    >
      <div class="upload-img-wrap" style="display: flex; position: relative;">
        <div v-if="localValue && !disabled" class="delete-icon" @click.stop="handleRemove">
          <comp-svg name="delete" fill="#ffffff"></comp-svg>
        </div>
        <img v-if="showUserInfo && userInfo.avatar" :src="userInfo.avatar" class="avatar" />
        <template v-else>
          <img v-if="localValue" :src="localValue" class="avatar" />
          <el-avatar v-else :size="60" fit="contain">
            <comp-icon name="default-avatar" size="60px"></comp-icon>
          </el-avatar>
        </template>
      </div>
    </el-upload>
    <div v-if="showUserInfo" class="upload-right">
      <div class="name">{{ userInfo.name }}</div>
      <div class="account">{{Lang.Title.userOrgAccount}}: {{ userInfo.account }}</div>
    </div>
    <div v-else class="upload-right">
      <div class="tips">{{ Lang.Text.userInfoUploadSize }}</div>
        <el-upload
          action="/api/blade-resource/oss/endpoint/put-file"
          :show-file-list="false"
          :on-success="handleAvatarSuccess"
          :before-upload="beforeAvatarUpload"
          :on-remove="handleRemove"
          :headers="headers"
          :disabled="disabled"
          >
          <div class="upload-btn">{{ Lang.btn.upload }}</div>
        </el-upload>
    </div>
  </div>
</template>

<script setup>
import { ref, watch } from 'vue';
import { ElMessage } from 'element-plus';
import { getToken } from '@/utils/auth';
import { useStore } from 'vuex';
import { Lang } from '@/lang/lang'

const props = defineProps({
  modelValue: {
    type: String,
    default: '',
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  showUserInfo: {
    type: Boolean,
    default: false,
  },
  userInfo: {
    type: Object,
    default: () => {}
  }
});

const emit = defineEmits(['update:value']);

const store = useStore();
const localValue = ref(props.value);
const headers = ref({
  'Blade-Requested-With': 'BladeHttpRequest',
  'Tenat-Id': store.getters.userInfo.tenant_id,
  'Blade-Auth': 'bearer ' + getToken(),
});

watch(() => props.modelValue, (newval) => {
  console.log('监听到', newval)
  localValue.value = newval;
}, { immediate: true }) // 确保初始值也会触发

const handleAvatarSuccess = (response) => {
  localValue.value = response.data.link;
  emit('update:value', response.data.link);
  emit('change', response.data.link);
};

const beforeAvatarUpload = (file) => {
  if (!['image/png', 'image/jpg', 'image/jpeg'].includes(file.type)) {
    ElMessage.error(Lang.Text.userInfoUploadSize);
    return false;
  } else if (file.size / 1024 / 1024 > 5) {
    ElMessage.error(Lang.Text.userInfoUploadSize);
    return false;
  }
  return true;
};

const handleRemove = () => {
  if (props.disabled) return;
  localValue.value = '';
  emit('update:value', '');
};
</script>

<style lang="scss" scoped>
.comp-upload-avatar-box {
  display: flex;
  justify-content: space-between;
  .upload-right {
    flex: 1;
    margin-left: 16px;
    font-family: Roboto-Regular;
    .name {
      color: #192434;
      font-size: 16px;
      font-weight: 600;
      line-height: 28px;
    }
    .account {
      color: #616D7C;
    }
  }
  .tips {
    color: #616D7C;
    font-size: 13px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px; /* 153.846% */
    letter-spacing: -0.26px;
    margin-bottom: 4px;
  }
  .upload-btn {
    display: flex;
    width: 68px;
    height: 24px;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    border-radius: 4px;
    border: 1px solid #2684FC;
    background: #FFF;
    color: #2684FC;
  }
}
.avatar-uploader {

}
.upload-img-wrap {
  position: relative;

  &:hover .delete-icon {
    display: flex; /* 在鼠标悬停时显示 delete-icon */
  }
}
.delete-icon {
  display: none;
  align-items: center;
  justify-content: center;
  color: #ffffff;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
  height: 100%;
  border-radius: 4px;
  background-color: rgba(0, 0, 0, 0.3);
}
</style>